import { useEffect, useState } from "react";
import { ITitleReferredImprove } from './useInformativeILayerTitle'
import { statusReferredType } from "../InformativeLayer.d";

const titleReferred: ITitleReferredImprove = {
  loading: { text: 'Estamos procesando tu información', },
  exit: { text: '¡Listo! Te contactaremos a la brevedad', },
  noExit: { text: 'Ya aceptaste que nos comuniquemos con vos', },
  error: { text: 'La información no está disponible', },
  expired: { text: 'El link venció, ¡pero todavía podés mejorar tu plan!', },
  limitExceeded: { text: 'No podemos referir a la empresa', },
}


export default function useInformativeTitle(status: statusReferredType): string {
  const [statusRefered, setStatusRefered] = useState<string>(null)

  useEffect(() => {
    switch (status) {
      case 'EXIT':
        setStatusRefered(titleReferred.exit.text)
        break
      case 'NOT_EXIT':
        setStatusRefered(titleReferred.noExit.text)
        break
      case 'ERROR':
        setStatusRefered(titleReferred.error.text)
        break
      case 'EXPIRED':
        setStatusRefered(titleReferred.expired.text)
        break
      case 'LIMIT_EXCEEDED':
        setStatusRefered(titleReferred.limitExceeded.text)
        break
      default:
        setStatusRefered(titleReferred.loading.text)
    }
  }, [status])
  return statusRefered
}
